export default __webpack_public_path__ + "img/60e56a80e2d7be28186ec8036227ff80.png";